import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { t } from 'i18next';
import Select, { StylesConfig, components } from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import fetchAPI from "../../../common/fetchAPI";
import { dropDownSelectionStyles, dateFormatByAccountCulture, getValueFromResource } from '../../../common/timeLiveFunction';
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { Dropdown } from 'react-bootstrap';
import moment from "moment";
import {
    updateMasterTimeExpenseBilling, getTimeExpenseBillingInvoice, updateMasterTimeExpenseBillingValues, updateAccountInvoice,
    updateMasterTimeExpenseBillingValuesByClient, deleteAccountInvoiceForm, getAccountInvoiceTemplateByClientId,
    UpdateMasterCurrencyExchangeRate
} from '../invoiceBillingSlice';
import { ShowSwalWithConfirmation } from "../../../common/SweetAlert";
import { ShowToast } from "../../../common/Toastr";
import { useNavigate } from "react-router-dom";
import { useDebounce } from "../../../_metronic/helpers";

const objDropdown = {
    billable: [],
    currencies: [],
    tax1: [],
    tax2: [],
    timesheetGroupType: [],
    expenseGroupType: [],
    showDiscountCalculation: [],
    accountProjectTask: [],
    accountPartyContact: [{ value: 0, label: 'None' }],
    accountEmployee: []
}

const objInvoiceValues = {
    isError: false,
    errorMessage: '',
    isShowEmployee: 'none'
}

interface DropdownItem {
    value: number;
    label: string;
}

const objScroll = {
    clients: true,
    projects: true
}

const GenerateInvoiceForm = () => {
    const storageTimeExpenseBillingId = localStorage.getItem('storageTimeExpenseBillingId');
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [page, setPage] = useState(1);
    const [projectPage, setProjectPage] = useState(1);
    const [clientLoading, setClientLoading] = useState(false);
    const [projectLoading, setProjectLoading] = useState(false);
    const [search, setSearch] = useState<string>('');
    const [projectSearch, setProjectSearch] = useState<string>('');
    const [hasMore, setHasMore] = useState(objScroll);
    const [dataClient, setDataClient] = useState<DropdownItem[]>([]);
    const [dataProjects, setDataProjects] = useState<DropdownItem[]>([]);
    const [selectedClient, setSelectedClient] = useState<DropdownItem | null>(null);
    const [selectedProject, setSelectedProject] = useState<DropdownItem | null>(null);
    const [invoiceResponse, setInvoiceResponse] = useState<any | ''>(objDropdown);
    const [invoiceValues, setInvoiceValues] = useState<any | ''>(objInvoiceValues);
    const [selectedOption, setSelectedOption] = useState<{ [object: string]: any }>();
    const [isFirstTimeCLoad, setIsFirstTimeCLoad] = useState(true);
    const [isFirstTimePLoad, setIsFirstTimePLoad] = useState(true);
    const { maxMenuHeight, accountBaseCurrencyId, invoiceNoPrefix, sessionAccountId, CurrentCultureDateFormat, cultureInfoName, dateInsertionFormat, calendarStartDay } = useAppSelector((state) => state.globalState);
    const { masterAccountTimeExpenseBilling, accountTimeExpenseBillingId } = useAppSelector((state) => state.invoiceBilling);
    const getMasterRecord: any = masterAccountTimeExpenseBilling[0];
    let prefixFromPreferences = invoiceNoPrefix + "-";
    // const scrollPosition = useRef(0);
    const scrollProjectPosition = useRef(0);
    const menuRef = useRef<HTMLDivElement | null>(null);
    useEffect(() => {
        renderInvoiceFilter();
    }, []);
    // useEffect(() => {
    //     renderClients(page, '').then((result) => {
    //         setIsFirstTimeCLoad(false);
    //     });
    // }, [page]);

    // const debouncedSearchTerm = useDebounce(search, 500);
    // useEffect(() => {
    //     if (!isFirstTimeCLoad) {
    //         search != "" && renderClients(page, search);
    //     }
    // }, [debouncedSearchTerm]);

    // useEffect(() => {
    //     if (menuRef.current) {
    //         menuRef.current.scrollTop = scrollPosition.current; // Restore scroll position
    //     }
    // }, [dataClient]);

    useEffect(() => {
        if (getMasterRecord.AccountClientId > 0) {
            renderProjectsByClientId(projectPage, '', getMasterRecord.AccountClientId).then((result) => {
                setIsFirstTimePLoad(false);
            });
        }
    }, [projectPage]);

    const debouncedPSearchTerm = useDebounce(projectSearch, 500);
    useEffect(() => {
        if (!isFirstTimePLoad) {
            projectSearch != "" && renderProjectsByClientId(projectPage, projectSearch, getMasterRecord.AccountClientId);
        }
    }, [debouncedPSearchTerm]);

    useEffect(() => {
        if (menuRef.current) {
            menuRef.current.scrollTop = scrollProjectPosition.current; // Restore scroll position
        }
    }, [dataProjects]);

    const renderInvoiceFilter = async () => {
        // let url = accountTimeExpenseBillingId != "" ? `api/V2/Invoice/GetAllDataInSingleRequest/${accountTimeExpenseBillingId}` : `api/V2/Invoice/GetAllDataInSingleRequest/`;
        //let url = storageTimeExpenseBillingId != "" ? `api/V2/Invoice/GetAllDataInSingleRequest/${invoiceNoPrefix}/${storageTimeExpenseBillingId}` : `api/V2/Invoice/GetAllDataInSingleRequest/${invoiceNoPrefix}/${storageTimeExpenseBillingId}`;
        let url = storageTimeExpenseBillingId != "" ? `api/V2/Invoice/GetAllDataInSingleRequest?InvoicePrefix=${invoiceNoPrefix}&AccountTimeExpenseBillingId=${storageTimeExpenseBillingId}` : `api/V2/Invoice/GetAllDataInSingleRequest?InvoicePrefix=${invoiceNoPrefix}&AccountTimeExpenseBillingId=${storageTimeExpenseBillingId}`;
        
        try {
            const response = await fetchAPI(url, 'Get', '', true);
            const json = await response.json();
            let billableArray = [
                { "value": -1, "label": "both" },
                { "value": 1, "label": "Billable" },
                { "value": 0, "label": "Non Billable" }
            ];
            let currenciesoptions = json["Currencies"].map((item: any)=>({
                value: item.AccountCurrencyId,
                label: item.CurrencyCode,
                ExchangeRate: item.ExchangeRate
            }))
            const baseCurrency = json["Currencies"].find(
                (item: any) => item.AccountCurrencyId === accountBaseCurrencyId
            );
            if (baseCurrency) {
                dispatch(UpdateMasterCurrencyExchangeRate(baseCurrency.ExchangeRate));
            }       

            // json["Currencies"].map((item: any) => {
            //     item.value = item.AccountCurrencyId;
            //     item.label = item.CurrencyCode;
            //     delete item.AccountCurrencyId;
            //     delete item.CurrencyCode;
            // });
            json["TaxCode"].map((item: any) => {
                item.value = item.AccountTaxCodeId;
                item.label = item.TaxCode;
                delete item.AccountTaxCodeId;
                delete item.TaxCode;
            });
            json["TaxCode"].unshift({ value: 0, label: 'Select' });
            let timesheetGroupTypeArray = [
                { "value": 0, "label": "Task" },
                { "value": 1, "label": "Time Entry" },
                { "value": 2, "label": "Parent Task" },
                { "value": 3, "label": "Employee" }
            ];
            let expenseGroupTypeArray = [
                { "value": 0, "label": "Expense Name" },
                { "value": 1, "label": "Expense Entry" }
            ];
            let showDiscountCalculationArray = [
                { "value": 0, "label": "Percentage" },
                { "value": 1, "label": "Fixed Amount" }
            ];
            json["AccountEmployee"].map((item: any) => {
                item.value = item.AccountEmployeeId;
                item.label = item.FirstName + " " + item.LastName;
                delete item.AccountEmployeeId;
                delete item.FirstName;
                delete item.LastName;
            });
            // setInvoiceResponse({
            //     ...invoiceResponse,
            //     billable: billableArray,
            //     currencies: json["Currencies"],
            //     tax1: json["TaxCode"],
            //     tax2: json["TaxCode"],
            //     timesheetGroupType: timesheetGroupTypeArray,
            //     expenseGroupType: expenseGroupTypeArray,
            //     showDiscountCalculation: showDiscountCalculationArray,
            //     accountEmployee: json["AccountEmployee"]
            // });
            updateInvoiceResponse({
                billable: billableArray,
                currencies: currenciesoptions,
                tax1: json["TaxCode"],
                tax2: json["TaxCode"],
                timesheetGroupType: timesheetGroupTypeArray,
                expenseGroupType: expenseGroupTypeArray,
                showDiscountCalculation: showDiscountCalculationArray,
                accountEmployee: json["AccountEmployee"]
            });
            setSelectedOption(json["AccountEmployee"]);
            let employeeArray: any[] = [];
            if (json["AccountEmployee"]?.length > 0) {
                json["AccountEmployee"]?.map((item: any) => {
                    employeeArray.push(item.value)
                });
            } else {
                employeeArray.push(0);
            }
            let masterInvoiceArray;
            let splitExpenseString;
            let accountClientId = 0;
            if (json["MasterTable"].length > 0) {
                masterInvoiceArray = json["MasterTable"];
                accountClientId = masterInvoiceArray[0].AccountClientId;
                splitExpenseString = masterInvoiceArray[0].GroupExpenseBillingListBy.toString().split(/(?=[A-Z])/);
                renderProjectsByClientId(1, '', accountClientId).then((result) => {
                    renderClientContactByClientId(accountClientId);
                });
            } else {
                masterInvoiceArray = [];
                splitExpenseString = '';
            }
            let tempArray = [];
            let tempObject = {
                "AccountClientContactId": storageTimeExpenseBillingId == "" ? 0 : masterInvoiceArray[0].AccountClientContactId,
                "AccountClientId": storageTimeExpenseBillingId == "" ? 0 : masterInvoiceArray[0].AccountClientId,
                "AccountCurrencyId": storageTimeExpenseBillingId == "" ? accountBaseCurrencyId : masterInvoiceArray[0].AccountCurrencyId,
                "AccountProjectId": storageTimeExpenseBillingId == "" ? 0 : masterInvoiceArray[0].AccountProjectId,
                "AccountTimeExpenseBillingId": storageTimeExpenseBillingId == "" ? "" : masterInvoiceArray[0].AccountTimeExpenseBillingId,
                "BankDetails": storageTimeExpenseBillingId == "" ? "" : masterInvoiceArray[0].BankDetails,
                "Billable": -1,
                // "BillingCycleEndDate": storageTimeExpenseBillingId == "" ? new Date() : new Date(masterInvoiceArray[0].BillingCycleEndDate),
                // "BillingCycleStartDate": storageTimeExpenseBillingId == "" ? new Date() : new Date(masterInvoiceArray[0].BillingCycleStartDate),
                "BillingCycleEndDate": storageTimeExpenseBillingId == "" ? new Date() : dateFormatByAccountCulture(masterInvoiceArray[0].BillingCycleEndDate, cultureInfoName.toString()),
                "BillingCycleStartDate": storageTimeExpenseBillingId == "" ? new Date() : dateFormatByAccountCulture(masterInvoiceArray[0].BillingCycleStartDate, cultureInfoName.toString()),
                "Description": storageTimeExpenseBillingId == "" ? "" : masterInvoiceArray[0].Description,
                "Discount": storageTimeExpenseBillingId == "" ? 0 : masterInvoiceArray[0].Discount,
                "DiscountPercentage": storageTimeExpenseBillingId == "" ? 0 : masterInvoiceArray[0].DiscountPercentage,
                "EmailTo": storageTimeExpenseBillingId == "" ? "" : masterInvoiceArray[0].EmailTo,
                "GrandTotal": storageTimeExpenseBillingId == "" ? 0 : masterInvoiceArray[0].GrandTotal,
                "GroupExpenseBillingListBy": storageTimeExpenseBillingId == "" ? expenseGroupTypeArray[0].label : splitExpenseString[0] + " " + splitExpenseString[1],
                "GroupTimesheetBillingListBy": storageTimeExpenseBillingId == "" ? timesheetGroupTypeArray[0].label : masterInvoiceArray[0].GroupTimesheetBillingListBy,
                // "InvoiceDate": storageTimeExpenseBillingId == "" ? new Date() : new Date(masterInvoiceArray[0].InvoiceDate),
                // "InvoiceDueDate": storageTimeExpenseBillingId == "" ? new Date() : new Date(masterInvoiceArray[0].DueDate),
                "InvoiceDate": storageTimeExpenseBillingId == "" ? new Date() : dateFormatByAccountCulture(masterInvoiceArray[0].InvoiceDate, cultureInfoName.toString()),
                "InvoiceDueDate": storageTimeExpenseBillingId == "" ? new Date() : dateFormatByAccountCulture(masterInvoiceArray[0].DueDate, cultureInfoName.toString()),
                "InvoiceNo": storageTimeExpenseBillingId == "" ? json["InvoiceNo"][0].InvoiceNo + 1 : Number(masterInvoiceArray[0].InvoiceNumber),
                "InvoicePrefix": storageTimeExpenseBillingId == "" ? invoiceNoPrefix : masterInvoiceArray[0].InvoicePrefix,
                "IsBilled": false,
                "IsEmailSend": 0,
                "IsPaid": storageTimeExpenseBillingId == "" ? false : masterInvoiceArray[0].IsPaid,
                "PONumber": storageTimeExpenseBillingId == "" ? "" : masterInvoiceArray[0].PONumber,
                "ParentAccountProjectTaskId": storageTimeExpenseBillingId == "" ? 0 : masterInvoiceArray[0].ParentAccountProjectTaskId,
                "ShowDiscountCalculationBy": storageTimeExpenseBillingId == "" ? 0 : masterInvoiceArray[0].ShowDiscountCalculationBy,
                "SubTotal": storageTimeExpenseBillingId == "" ? 0 : masterInvoiceArray[0].SubTotal,
                "TaxCode1": storageTimeExpenseBillingId == "" ? 0 : masterInvoiceArray[0].TaxCode1,
                "TaxCode2": storageTimeExpenseBillingId == "" ? 0 : masterInvoiceArray[0].TaxCode2,
                "Terms": storageTimeExpenseBillingId == "" ? "" : masterInvoiceArray[0].Terms,
                "filterEmployees": employeeArray.toString(),
                "AccountTaxCodeId1": 0,
                "AccountTaxCodeId2": 0
            }
            tempArray.push(tempObject);
            renderClients();
            dispatch(updateMasterTimeExpenseBilling(tempArray));
        } catch (error) {
        } finally {
        }
    }

    const updateInvoiceResponse = async (updates: any) => {
        await new Promise(resolve => setTimeout(resolve, 0));
        setInvoiceResponse((prevState: any) => ({
            ...prevState,
            ...updates
        }));
    };

    // const renderClients = async (pageNum: any, search: string) => {
    const renderClients = async () => {
        setClientLoading(true);
        try {
            // // const searchParam = search != "" ? search : '';
            // // const response: any = await fetchAPI(`api/V2/Clients/GetClientNameAndIdForDropdown/${0}/${pageNum}/${searchParam}`, "GET", "", true);
            // const searchParam = search ? `&search=${search}` : "";
            // const response: any = await fetchAPI(`api/V2/Clients/Dropdown/0?page=${pageNum}${searchParam}`, "GET", "", true);
            const response: any = await fetchAPI(`api/V2/Clients/ClientDropdownForReact/${sessionAccountId}/0`, "GET", "", true);
            const json = await response.json();
            const transformedData = json.items.map((item: any) => ({
                value: item.id,
                label: item.text
            }));
            transformedData.unshift({ value: 0, label: 'Select' });
            const newItemsClients = transformedData.filter((item: any) => !dataClient.some((existingItem: any) => existingItem.value === item.value));
            setDataClient((prevData) => [...prevData, ...newItemsClients]);
            setSelectedClient(transformedData[0]);
            // setHasMore({
            //     ...hasMore,
            //     clients: newItemsClients.length > 0 ? true : false
            // })
        } catch (error) {
            setClientLoading(false);
        } finally {
            setClientLoading(false);
        }
    }

    const renderProjectsByClientId = async (pageNum: any, search: string, accountClientId: number = 0) => {
        setProjectLoading(true);
        if (pageNum === 1) {
            setDataProjects([]);
            setSelectedProject(null);
        }
        try {
            // setSelectedProject(null);
            // setDataProjects([]);
            // const searchParam = search != "" ? search : '';
            // const response: any = await fetchAPI(`api/V2/Projects/ByClientForDropdown/${accountClientId}/${0}/${pageNum}/${searchParam}`, "GET", "", true);
            const searchParam = search ? `&search=${search}` : "";
            const response: any = await fetchAPI(`api/V2/Projects/ByClientForDropdown/${accountClientId}/?AccountProjectId=${0}&page=${pageNum}${searchParam}`, "GET", "", true);
            const json = await response.json();
            const transformedData = json.Data.items.map((item: any) => ({
                value: item.id,
                label: item.text
            }));
            transformedData.unshift({ value: 0, label: 'Select' });
            setDataProjects((prevData) =>
            pageNum === 1 ? transformedData : [
                ...prevData,
                ...transformedData.filter(
                    (item: any) => !prevData.some((existing: any) => existing.value === item.value)
                )
            ]
        );
        setSelectedProject(transformedData[0]);
        setHasMore({ ...hasMore, projects: json.Data.items.length > 0 });
            // const newItemsProjects = transformedData.filter((item: any) => !dataProjects.some((existingItem: any) => existingItem.value === item.value));
            // setDataProjects((prevData) => [...prevData, ...newItemsProjects]);
            // setHasMore({
            //     ...hasMore,
            //     projects: newItemsProjects.length > 0 ? true : false
            // })
            storageTimeExpenseBillingId === "" && dispatch(getAccountInvoiceTemplateByClientId(accountClientId));
        } catch (error) {
            setProjectLoading(false);
        } finally {
            setProjectLoading(false);
        }
    }

    const renderProjectTasksByProjectId = async (accountProjectId: number) => {
        setInvoiceResponse({
            ...invoiceResponse,
            accountProjectTask: []
        });
        try {
            const response: any = await fetchAPI(`api/V2/Tasks/ParentTasksByAccountProjectIdForInvoice/?AccountProjectId=${accountProjectId}`, "GET", "", true);
            const json = await response.json();
            const transformedData = json.Data.items.map((item: any) => ({
                value: item.id,
                label: item.text
            }));
            transformedData.unshift({ value: 0, label: 'Select' });
            setInvoiceResponse({
                ...invoiceResponse,
                accountProjectTask: transformedData
            });
        } catch (error) {
        } finally {
        }
    }

    const renderClientContactByClientId = async (accountClientId: number) => {
        try {
            const response: any = await fetchAPI(`api/V2/Clients/Contacts/${accountClientId}`, "GET", "", true);
            const json = await response.json();
            let transformedData = [];
            if (json.Data.length > 0) {
                transformedData = json.Data.map((item: any) => ({
                    value: item.AccountPartyContactId,
                    label: item.PartyContact
                }));
                transformedData.unshift({ value: 0, label: 'None' });
            } else {
                transformedData.push({ value: 0, label: 'None' })
            }
            // setInvoiceResponse({
            //     ...invoiceResponse,
            //     accountPartyContact: transformedData
            // });
            updateInvoiceResponse({
                accountPartyContact: transformedData
            });
        } catch (error) {
        } finally {
        }
    }

    const getAccountInvoiceNo = async (invoiceNo: string) => {
        // let tempInvoice = invoiceNoPrefix === "" ? invoiceNo : invoiceNo.split(prefixFromPreferences)[1];
        // let tempInvoice = invoiceNoPrefix === "" ? invoiceNo : invoiceNo.slice(prefixFromPreferences.length);
        try {
            const response: any = await fetchAPI(`api/V2/Invoice/IsDuplicateInvoiceNo?InvoiceNo=${masterAccountTimeExpenseBilling[0].InvoiceNo}&AccountTimeExpenseBillingId=${"00000000-0000-0000-0000-000000000000"}&ResetInvoiceNo=${'False'}&InvoiceNoPrefix=${''}`, "GET", "", true);
            const json = await response.json();
            if (Number(json.Id) === -1) {
                setInvoiceValues({
                    ...invoiceValues,
                    errorMessage: json.ResponseMessage,
                    isError: true
                });
            } else {
                setInvoiceValues({
                    ...invoiceValues,
                    errorMessage: "",
                    isError: false
                });
            }
        } catch (error) {
        } finally {
        }
    }

    const handleScroll = (e: React.UIEvent<HTMLDivElement>, control: any) => {
        if (control === 'clientArray') {
            // // const bottom = e.currentTarget.scrollHeight - e.currentTarget.scrollTop === e.currentTarget.clientHeight;
            // // if (bottom && hasMore.clients && !clientLoading) {
            // //     setPage((prevPage) => prevPage + 1);
            // // }
            // scrollPosition.current = e.currentTarget.scrollTop;
            // if (hasMore.clients && !clientLoading) {
            //     const bottom = e.currentTarget.scrollHeight - e.currentTarget.scrollTop === e.currentTarget.clientHeight;
            //     if (bottom) {
            //         setPage((prevPage) => prevPage + 1);
            //     }
            // }
        } else {
            // const bottom = e.currentTarget.scrollHeight - e.currentTarget.scrollTop === e.currentTarget.clientHeight;
            // if (bottom && hasMore.projects && !projectLoading) {
            //     setProjectPage((prevPage) => prevPage + 1);
            // }
            scrollProjectPosition.current = e.currentTarget.scrollTop;
            if (hasMore.projects && !projectLoading) {
                // const bottom = e.currentTarget.scrollHeight - e.currentTarget.scrollTop === e.currentTarget.clientHeight;
                const el = e.currentTarget;
                const bottom = el.scrollHeight - el.scrollTop <= el.clientHeight + 1;
                if (bottom) {
                    setProjectPage((prevPage) => prevPage + 1);
                }
            }
        }
    }

    const customMenuList = (props: any) => {
        const { children, maxHeight, getValue } = props;
        const handleMenuScroll = (e: React.UIEvent<HTMLDivElement>) => {
            handleScroll(e, props.selectProps.name);
        }
        return (
            <div onScroll={handleMenuScroll}
                style={{ maxHeight, overflowY: 'auto' }}>
                {children}
            </div>
        )
    }

    const handleChangeOption = (selected: any, control: any) => {
        if (control.name === "clientArray") {
            dispatch(updateMasterTimeExpenseBillingValuesByClient([{ "item": "AccountClientId", "value": selected.value },
            { "item": "AccountProjectId", "value": 0 }, { "item": "ParentAccountProjectTaskId", "value": 0 }, { "item": "AccountClientContactId", "value": 0 }]));
            setSelectedClient(selected);
            renderProjectsByClientId(1, '', selected.value).then((result) => {
                renderClientContactByClientId(selected.value);
            });
        } else if (control.name === "projectArray") {
            dispatch(updateMasterTimeExpenseBillingValuesByClient([{ "item": "AccountProjectId", "value": selected.value }, { "item": "ParentAccountProjectTaskId", "value": 0 }]));
            setSelectedProject(selected);
            
            renderProjectTasksByProjectId(selected.value);
        } else if (control.name === "taskArray") {
            dispatch(updateMasterTimeExpenseBillingValues({ "item": "ParentAccountProjectTaskId", "value": selected.value }));
        }
    }

    // const handleInputTeam = (inputValue: string, control: any) => {
    //     if (control.name === "clientArray") {
    //         setSearch(inputValue);
    //     } else {
    //         setProjectSearch(inputValue);
    //     }
    // }

    const onChangeEmployeeFilter = (data: any) => {
        setSelectedOption(data);
        let employeeArray: any[] = [];
        if (data?.length > 0) {
            data?.map((item: any) => {
                employeeArray.push(item.value)
            });
        } else {
            employeeArray.push(0);
        }
        dispatch(updateMasterTimeExpenseBillingValues({ "item": "filterEmployees", "value": employeeArray.toString() }))
    }

    const submitFilters = (populate: string) => {
        if (accountTimeExpenseBillingId != "") {
            confiramtionAndDeleteRecord(populate);
        }
        else {
            updateAccountInvoiceForm(populate);
        }
    }

    const updateAccountInvoiceForm = (populate: any) => {
        let employeeArray: any[] = [];
        if (selectedOption?.length > 0) {
            selectedOption?.map((item: any) => {
                employeeArray.push(item.value)
            });
        } else {
            employeeArray.push(0);
        }
        const object = {
            "grouptype": getMasterRecord.GroupTimesheetBillingListBy,
            "accountClientId": getMasterRecord.AccountClientId,
            "billingCycleStartDate": moment(getMasterRecord.BillingCycleStartDate).format(dateInsertionFormat),
            "billingCycleEndDate": moment(getMasterRecord.BillingCycleEndDate).format(dateInsertionFormat),
            "accountProjectId": getMasterRecord.AccountProjectId,
            "accountCurrencyId": getMasterRecord.AccountCurrencyId,
            "billable": getMasterRecord.Billable,
            "accountProjectTaskId": getMasterRecord.ParentAccountProjectTaskId,
            "expenseInvoiceGroup": getMasterRecord.GroupExpenseBillingListBy.replace(/\s/g, ''),
            "invoiceRecordsFor": (populate == "Both" ? -1 : (populate == "Timesheet" ? 0 : 1)),
            "isTimesheetRefresh": (populate == "Timesheet" || populate == "Both" ? true : false),
            "isExpenseRefresh": (populate == "Expense" || populate == "Both" ? true : false),
            "filterEmployees": employeeArray.toString(),
            "AccountTaxCodeId1": getMasterRecord.AccountTaxCodeId1,
            "AccountTaxCodeId2": getMasterRecord.AccountTaxCodeId2
        }
        dispatch(getTimeExpenseBillingInvoice(object))
            .then((response) => {
                if (response.payload.json[0][0].hasOwnProperty('Message') && response.payload.json[1][0].hasOwnProperty('Message')) {
                    ShowToast('warning', "No Record Found", "warning", "toast-top-right");
                } else {
                    confiramtionAndUpdateRecord();
                }
            });
    }

    const confiramtionAndDeleteRecord = (populate: any) => {
        let isMessageHeader = (populate === 'Both' ? 'Are you sure to refresh data?' : (populate === 'Timesheet' ? "Are you sure to refresh your timesheet data?" : "Are you sure to refresh your expense data?"));
        let isMessageBody = (populate === 'Both' ? 'All your existing populated data will be deleted and refreshed by this action?' : (populate === 'Timesheet' ? "All your existing timesheet populated data will be deleted and refreshed by this action?" : "All your existing expense populated data will be deleted and refreshed by this action?"));
        ShowSwalWithConfirmation(isMessageHeader, isMessageBody, "Delete", 'custom-swal-container')
            .then((result) => {
                if (result) {
                    const object = {
                        "AccountTimeExpenseBillingId": accountTimeExpenseBillingId,
                        "invoiceRecordsFor": (populate == "Both" ? -1 : (populate == "Timesheet" ? 0 : 1)),
                        "isTimesheetRefresh": (populate == "Timesheet" || populate == "Both" ? true : false),
                        "isExpenseRefresh": (populate == "Expense" || populate == "Both" ? true : false)
                    }
                    dispatch(deleteAccountInvoiceForm(object)).then((response) => {
                        response.payload[0].Message === "Record(s) Removed Successfully!" && updateAccountInvoiceForm(populate);
                    }).catch((error) => {
                    });
                }
            })
            .catch((error) => {
            });
    }

    const confiramtionAndUpdateRecord = () => {
        ShowSwalWithConfirmation('Please click on update button to save your invoice.', "", "Update", 'custom-swal-container')
            .then((result) => {
                if (result) {
                    dispatch(updateAccountInvoice()).then((result) => {
                        if (result.payload.StatusCode === "200") {
                            ShowToast('Success', "Invoice Updated Successfully", "success", "toast-top-right");
                        } else {
                            ShowToast('error', "Invoice Updated Failed", "error", "toast-top-right");
                        }
                        navigate('/accounttimeexpensebilling');
                    }).catch((error) => {
                    });
                }
            })
            .catch((error) => {
            });
    }

    const updateInoiceNo = (e: any, invoicePrefix: string) => {
        const newValue = e.target.value;
        if (storageTimeExpenseBillingId === "" && invoiceNoPrefix === "") {
            dispatch(updateMasterTimeExpenseBillingValues({ "item": "InvoiceNo", "value": newValue }))
        }
        else if (storageTimeExpenseBillingId != "") {
            newValue.startsWith(invoicePrefix) ?
                dispatch(updateMasterTimeExpenseBillingValues({ "item": "InvoiceNo", "value": newValue.slice(invoicePrefix.length) })) :
                dispatch(updateMasterTimeExpenseBillingValues({ "item": "InvoiceNo", "value": newValue }));
        }
        else if (newValue.startsWith(prefixFromPreferences)) {
            dispatch(updateMasterTimeExpenseBillingValues({ "item": "InvoiceNo", "value": newValue.slice(prefixFromPreferences.length) }))
            const extractedPrefix = newValue.split('-')[0]; // Splits at '-' and takes the first part
            dispatch(updateMasterTimeExpenseBillingValues({ "item": "InvoicePrefix", "value": extractedPrefix }));
        }
    }

    return (
        <>
            <div className='card-body py-3' style={{ overflowY: 'auto' }}>
                <div className='row'>
                    <div className="col-md-4">
                        <label className="form-label fs-7 fw-normal mb-2">
                        {getValueFromResource('Invoice No',dispatch, t)}
                            </label>
                        <input
                            type="text"
                            className="form-control fs-7 fw-normal"
                            name='InvoiceNo'
                            value={storageTimeExpenseBillingId === "" ? (invoiceNoPrefix === "" ? getMasterRecord.InvoiceNo : prefixFromPreferences + getMasterRecord.InvoiceNo) 
                                : (getMasterRecord.InvoicePrefix && getMasterRecord.InvoicePrefix.trim() !== "" 
                                ? `${getMasterRecord.InvoicePrefix}-${getMasterRecord.InvoiceNo}` 
                                : getMasterRecord.InvoiceNo)}
                            onChange={(e: any) => {
                                // dispatch(updateMasterTimeExpenseBillingValues({ "item": "InvoiceNo", "value": e.target.value }))
                                updateInoiceNo(e, getMasterRecord.InvoicePrefix + "-")
                            }}
                            onBlur={(e) => { getAccountInvoiceNo(e.target.value) }}
                        />
                        <div>
                            {invoiceValues.isError &&
                                <p className='errorMsg'>{invoiceValues.errorMessage as string}</p>
                            }
                        </div>
                    </div>
                    <div className="col-md-4">
                        <label className="form-label fs-7 fw-normal mb-2">
                            {/* {t('PO Number')} */}
                            {getValueFromResource('PO Number',dispatch, t)}
                            </label>
                        <input
                            type="text"
                            className="form-control fs-7 fw-normal"
                            name='PONumber'
                            value={getMasterRecord.PONumber}
                            onChange={(e) => {
                                dispatch(updateMasterTimeExpenseBillingValues({ "item": "PONumber", "value": e.target.value }))
                            }}
                        />
                    </div>
                    <div className="col-md-4">
                        <label className="form-label fs-7 fw-normal mb-2">
                            {/* {t('Billable')} */}
                            {getValueFromResource('Billable',dispatch, t)}
                            </label>
                        <Select
                            value={invoiceResponse.billable.filter((x: any) => x.value == getMasterRecord.Billable)}
                            className="basic-single fs-7 fw-normal"
                            classNamePrefix="select"
                            name="billableArray"
                            onChange={(e, name) => dispatch(updateMasterTimeExpenseBillingValues({ "item": "Billable", "value": invoiceResponse.billable.filter((x: any) => x.value == e.value)[0].value }))}
                            options={invoiceResponse.billable}
                            styles={dropDownSelectionStyles}
                            maxMenuHeight={maxMenuHeight}
                        />
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-md-4">
                        <label className="form-label fs-7 fw-normal mb-2">
                            {/* {t('Client Name')} */}
                            {getValueFromResource('Client Name',dispatch, t)}
                            </label>
                        <div>
                            <Select
                                value={accountTimeExpenseBillingId == "" ? selectedClient : (dataClient.filter(x => x.value === getMasterRecord.AccountClientId).length > 0 ? dataClient.filter(x => x.value === getMasterRecord.AccountClientId) : { value: getMasterRecord.AccountClientId, label: getMasterRecord.ClientName })}
                                className="basic-single fs-7 fw-normal"
                                classNamePrefix="select"
                                name="clientArray"
                                onChange={(e, name) => handleChangeOption(e, name)}
                                options={dataClient}
                                styles={dropDownSelectionStyles}
                                // styles={{ menuList: (provided) => ({ ...provided }) }}
                                maxMenuHeight={maxMenuHeight}
                                // onInputChange={(e, name) => handleInputTeam(e, name)}
                                // onInputChange={(e, name) => setSearch(e)}
                                // components={{ MenuList: customMenuList }}
                                // components={{ MenuList: (props) => customMenuList({ ...props, innerRef: menuRef }) }}
                                isDisabled={accountTimeExpenseBillingId == "" ? false : true}
                            // isLoading={clientLoading}
                            />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <label className="form-label fs-7 fw-normal mb-2">
                            {/* {t('Project Name')} */}
                            {getValueFromResource('Project Name',dispatch, t)}
                            </label>
                        <div onScroll={(e) => handleScroll(e, "projectArray")}>
                            <Select
                                // value={selectedProject}
                                value={accountTimeExpenseBillingId == "" ? selectedProject : (dataProjects.filter(x => x.value === getMasterRecord.AccountProjectId).length > 0 ? dataProjects.filter(x => x.value === getMasterRecord.AccountProjectId) : { value: getMasterRecord.AccountProjectId, label: getMasterRecord.ProjectName })}
                                className="basic-single fs-7 fw-normal"
                                classNamePrefix="select"
                                name="projectArray"
                                onChange={(e, name) => handleChangeOption(e, name)}
                                options={dataProjects}
                                styles={dropDownSelectionStyles}
                                maxMenuHeight={maxMenuHeight}
                                // onInputChange={(e, name) => handleInputTeam(e, name)}
                                onInputChange={(e, name) => setProjectSearch(e)}
                                //components={{ MenuList: customMenuList }}
                                components={{ MenuList: (props) => customMenuList({ ...props, innerRef: menuRef }) }}
                                isDisabled={accountTimeExpenseBillingId != "" ? false : (selectedClient != undefined ? selectedClient?.value > 0 ? false : true : true)}
                                isLoading={projectLoading}
                            />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <label className="form-label fs-7 fw-normal mb-2">
                            {/* {t('Task Name')} */}
                            {getValueFromResource('Task Name',dispatch, t)}
                            </label>
                        <Select
                            value={invoiceResponse.accountProjectTask.filter((x: any) => x.value == getMasterRecord.ParentAccountProjectTaskId)}
                            className="basic-single fs-7 fw-normal"
                            classNamePrefix="select"
                            name="taskArray"
                            onChange={(e, name) => handleChangeOption(e, name)}
                            options={invoiceResponse.accountProjectTask}
                            styles={dropDownSelectionStyles}
                            maxMenuHeight={maxMenuHeight}
                            isDisabled={selectedProject != undefined ? selectedProject?.value > 0 ? false : true : true}
                        />
                    </div>
                </div>
                <div className='row mt-4'>
                    <div className="col-md-4">
                        <label className="form-label fs-7 fw-normal mb-2">
                            {/* {t('Invoice Date')} */}
                            {getValueFromResource('Invoice Date',dispatch, t)}
                            </label>
                        <div className="wrapper">
                            <DatePicker
                                selected={getMasterRecord.InvoiceDate !== "" ? dateFormatByAccountCulture(moment.parseZone(getMasterRecord.InvoiceDate).format("YYYY-MM-DD"), cultureInfoName.toString()) : new Date()}
                                onChange={(date) => dispatch(updateMasterTimeExpenseBillingValues({ "item": "InvoiceDate", "value": date }))}
                                calendarStartDay={calendarStartDay}
                                className="form-control form-control-dark btn-icon-dark btn-text-dark fs-7 fw-normal"
                                dateFormat={CurrentCultureDateFormat.toString()}
                            >
                            </DatePicker>
                            <i className="insideField-Icons ki-outline ki-calendar text-gray"></i>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <label className="form-label fs-7 fw-normal mb-2">
                            {/* {t('Billing Cycle Start Date')} */}
                            {getValueFromResource('Billing Cycle Start Date',dispatch, t)}
                            </label>
                        <div className="wrapper">
                            <DatePicker
                            selected={getMasterRecord.BillingCycleStartDate !== "" ? dateFormatByAccountCulture(moment.parseZone(getMasterRecord.BillingCycleStartDate).format("YYYY-MM-DD"), cultureInfoName.toString()) : new Date()}
                                onChange={(date) => dispatch(updateMasterTimeExpenseBillingValues({ "item": "BillingCycleStartDate", "value": date }))}
                                calendarStartDay={calendarStartDay}
                                className="form-control form-control-dark btn-icon-dark btn-text-dark fs-7 fw-normal"
                                dateFormat={CurrentCultureDateFormat.toString()}
                            >
                            </DatePicker>
                            <i className="insideField-Icons ki-outline ki-calendar text-gray"></i>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <label className="form-label fs-7 fw-normal mb-2">
                            {/* {t('Billing Cycle End Date')} */}
                            {getValueFromResource('Billing Cycle End Date',dispatch, t)} 
                            </label>
                        <div className="wrapper">
                            <DatePicker
                            selected={getMasterRecord.BillingCycleEndDate !== "" ? dateFormatByAccountCulture(moment.parseZone(getMasterRecord.BillingCycleEndDate).format("YYYY-MM-DD"), cultureInfoName.toString()) : new Date()}
                             onChange={(date) => dispatch(updateMasterTimeExpenseBillingValues({ "item": "BillingCycleEndDate", "value": date }))}
                             calendarStartDay={calendarStartDay}
                                className="form-control form-control-dark btn-icon-dark btn-text-dark fs-7 fw-normal"
                                dateFormat={CurrentCultureDateFormat.toString()}
                            >
                            </DatePicker>
                            <i className="insideField-Icons ki-outline ki-calendar text-gray"></i>
                        </div>
                    </div>
                </div>
                <div className='row mt-4'>
                    <div className="col-md-4">
                        <label className="form-label fs-7 fw-normal mb-2">
                            {/* {t('Currency')} */}
                            {getValueFromResource('Currency',dispatch, t)} 
                            </label>
                        <Select
                            //value={invoiceResponse.currencies.filter((x: any) => x.value == getMasterRecord.AccountCurrencyId)}
                            value={invoiceResponse.currencies.filter((x: any) =>  x.value === (invoiceResponse.currencies.some((c: any) => c.value === getMasterRecord.AccountCurrencyId)? getMasterRecord.AccountCurrencyId : accountBaseCurrencyId))}
                            className="basic-single fs-7 fw-normal"
                            classNamePrefix="select"
                            name="currenciesArray"
                           // onChange={(e, name) => dispatch(updateMasterTimeExpenseBillingValues({ "item": "AccountCurrencyId", "value": invoiceResponse.currencies.filter((x: any) => x.value == e.value)[0].value }))}
                            onChange={(e, name) => {
                                dispatch(updateMasterTimeExpenseBillingValues({ item: "AccountCurrencyId", value: invoiceResponse.currencies.filter((x: any) => x.value == e.value)[0].value }));
                                dispatch(UpdateMasterCurrencyExchangeRate(invoiceResponse.currencies.filter((x: any) => x.value == e.value)[0].ExchangeRate));
                            }}
                            options={invoiceResponse.currencies}
                            styles={dropDownSelectionStyles}
                            maxMenuHeight={maxMenuHeight}
                        />
                    </div>
                    <div className="col-md-4">
                        <label className="form-label fs-7 fw-normal mb-2">
                            {/* {t('Tax 1')} */}
                            {getValueFromResource('Tax 1',dispatch, t)} 
                            </label>
                        <Select
                            value={invoiceResponse.tax1.filter((x: any) => x.value == (getMasterRecord.AccountTaxCodeId1 === null ? 0 : getMasterRecord.AccountTaxCodeId1))}
                            className="basic-single fs-7 fw-normal"
                            classNamePrefix="select"
                            name="tax1Array"
                            //onChange={(e, name) => dispatch(updateMasterTimeExpenseBillingValues({ "item": "AccountTaxCodeId1", "value": invoiceResponse.tax1.filter((x: any) => x.value == e.value)[0].value }))}
                            onChange={(e, name) => {
                                const selectedOption = invoiceResponse.tax1.find((x: any) => x.value == e.value);
                                dispatch(updateMasterTimeExpenseBillingValues({
                                  item: "AccountTaxCodeId1",
                                  value: selectedOption.value,
                                  taxNameField: "TaxName1",
                                  taxName: selectedOption.label // or whatever key holds the name
                                }));
                              }}
                            options={invoiceResponse.tax1}
                            styles={dropDownSelectionStyles}
                            maxMenuHeight={maxMenuHeight}
                        />
                    </div>
                    <div className="col-md-4">
                        <label className="form-label fs-7 fw-normal mb-2">
                            {/* {t('Tax 2')} */}
                            {getValueFromResource('Tax 2',dispatch, t)} 
                            </label>
                        <Select
                            value={invoiceResponse.tax1.filter((x: any) => x.value == (getMasterRecord.AccountTaxCodeId2 === null ? 0 : getMasterRecord.AccountTaxCodeId2))}
                            className="basic-single fs-7 fw-normal"
                            classNamePrefix="select"
                            name="tax2Array"
                            onChange={(e, name) => dispatch(updateMasterTimeExpenseBillingValues({ "item": "AccountTaxCodeId2", "value": invoiceResponse.tax1.filter((x: any) => x.value == e.value)[0].value }))}
                            options={invoiceResponse.tax2}
                            styles={dropDownSelectionStyles}
                            maxMenuHeight={maxMenuHeight}
                        />
                    </div>
                </div>
                <div className='row mt-4'>
                    <div className="col-md-4">
                        <label className="form-label fs-7 fw-normal mb-2">
                            {/* {t('Group Timesheet Billing List By')} */}
                            {getValueFromResource('Group Timesheet Billing List By',dispatch, t)} 
                            </label>
                        <Select
                            value={invoiceResponse.timesheetGroupType.filter((x: any) => x.label == getMasterRecord.GroupTimesheetBillingListBy)}
                            className="basic-single fs-7 fw-normal"
                            classNamePrefix="select"
                            name="timesheetGroupTypeArray"
                            onChange={(e, name) => {
                                dispatch(updateMasterTimeExpenseBillingValues({ "item": "GroupTimesheetBillingListBy", "value": invoiceResponse.timesheetGroupType.filter((x: any) => x.value == e.value)[0].label }))
                                setInvoiceValues({
                                    ...invoiceValues,
                                    isShowEmployee: e.value === 3 ? 'flex' : 'none'
                                });
                            }}
                            options={invoiceResponse.timesheetGroupType}
                            styles={dropDownSelectionStyles}
                            maxMenuHeight={maxMenuHeight}
                            isDisabled={accountTimeExpenseBillingId == "" ? false : true}
                        />
                    </div>
                    <div className="col-md-4">
                        <label className="form-label fs-7 fw-normal mb-2">
                            {/* {t('Group Expense Billing List By')} */}
                            {getValueFromResource('Group Expense Billing List By',dispatch, t)} 
                            </label>
                        <Select
                            value={invoiceResponse.expenseGroupType.filter((x: any) => x.label == getMasterRecord.GroupExpenseBillingListBy)}
                            className="basic-single fs-7 fw-normal"
                            classNamePrefix="select"
                            name="expenseGroupTypeArray"
                            onChange={(e, name) => dispatch(updateMasterTimeExpenseBillingValues({ "item": "GroupExpenseBillingListBy", "value": invoiceResponse.expenseGroupType.filter((x: any) => x.value == e.value)[0].label }))}
                            options={invoiceResponse.expenseGroupType}
                            styles={dropDownSelectionStyles}
                            maxMenuHeight={maxMenuHeight}
                        />
                    </div>
                    <div className="col-md-4">
                        <label className="form-label fs-7 fw-normal mb-2">
                            {/* {t('Discount Calculation By')} */}
                            {getValueFromResource('Discount Calculation By',dispatch, t)} 
                            </label>
                        <Select
                            value={invoiceResponse.showDiscountCalculation.filter((x: any) => x.value == getMasterRecord.ShowDiscountCalculationBy)}
                            className="basic-single fs-7 fw-normal"
                            classNamePrefix="select"
                            name="discountCalculationArray"
                            onChange={(e, name) => dispatch(updateMasterTimeExpenseBillingValues({ "item": "ShowDiscountCalculationBy", "value": invoiceResponse.showDiscountCalculation.filter((x: any) => x.value == e.value)[0].value }))}
                            options={invoiceResponse.showDiscountCalculation}
                            styles={dropDownSelectionStyles}
                            maxMenuHeight={maxMenuHeight}
                        />
                    </div>
                </div>
                <div className="row mt-4">
                    {invoiceValues.isShowEmployee === 'flex' && <div className="col-md-4">
                        <label className="form-label fs-7 fw-normal mb-2">
                            {/* {t('Employee Name')} */}
                            {getValueFromResource('Employee Name',dispatch, t)} 
                            </label>
                        <Select
                            value={selectedOption}
                            className="basic-single"
                            classNamePrefix="select"
                            name="accountEmployeeArray"
                            onChange={(e) => onChangeEmployeeFilter(e)}
                            options={invoiceResponse.accountEmployee}
                            styles={dropDownSelectionStyles}
                            maxMenuHeight={maxMenuHeight}
                            isMulti
                            closeMenuOnSelect={false}
                            components={{ MultiValue }}
                            hideSelectedOptions={false}
                        />
                    </div>}
                    <div className="col-md-4">
                        <label className="form-label fs-7 fw-normal mb-2">
                            {/* {t('Client Contact Information')} */}
                            {getValueFromResource('Client Contact Information',dispatch, t)} 
                            </label>
                        <Select
                            value={invoiceResponse.accountPartyContact.filter((x: any) => x.value == getMasterRecord.AccountClientContactId)}
                            className="basic-single fs-7 fw-normal"
                            classNamePrefix="select"
                            name="partyContactArray"
                            onChange={(e, name) => dispatch(updateMasterTimeExpenseBillingValues({ "item": "AccountClientContactId", "value": invoiceResponse.accountPartyContact.filter((x: any) => x.value == e.value)[0].value }))}
                            options={invoiceResponse.accountPartyContact}
                            styles={dropDownSelectionStyles}
                            maxMenuHeight={maxMenuHeight}
                            isDisabled={accountTimeExpenseBillingId != "" ? false : (selectedClient != undefined ? selectedClient?.value > 0 ? false : true : true)}
                        />
                    </div>
                    <div className="col-md-4">
                        <label className="form-label fs-7 fw-normal mb-2">
                            {/* {t('Invoice Due Date')} */}
                            {getValueFromResource('Invoice Due Date',dispatch, t)} 
                            </label>
                        <div className="wrapper">
                            <DatePicker
                               selected={getMasterRecord.InvoiceDueDate !== "" ? dateFormatByAccountCulture(moment.parseZone(getMasterRecord.InvoiceDueDate).format("YYYY-MM-DD"), cultureInfoName.toString()) : new Date()}
                                onChange={(date) => dispatch(updateMasterTimeExpenseBillingValues({ "item": "InvoiceDueDate", "value": date }))}
                                calendarStartDay={calendarStartDay}
                                className="form-control form-control-dark btn-icon-dark btn-text-dark fs-7 fw-normal"
                                dateFormat={CurrentCultureDateFormat.toString()}
                            >
                            </DatePicker>
                            <i className="insideField-Icons ki-outline ki-calendar text-gray"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div className='card-footer pt-4'>
                <div className='d-flex flex-end'>
                    <button
                        type="button"
                        className="btn btn-secondary btn-bs-btn-font-weight  me-2 btn-sm fs-7"
                        id="kt_OffCanvas"
                    >
                        {/* {t('Cancel')} */}
                        {getValueFromResource('Cancel',dispatch, t)}   
                    </button>
                    <div className="btn-group">
                        <button
                            type="button"
                            className="btn btn-primary btn-bs-btn-font-weight btn-sm"
                            onClick={() => submitFilters("Both")}
                        ><i className="bi bi-filter fs-5 me-1"></i> 
                        {/* {t('Populate Un-Billed Records')} */}
                        {getValueFromResource('Populate Un-Billed Records',dispatch, t)}                       
                         </button>
                        <button type="button" className="btn btn-primary btn-bs-btn-font-weight btn-sm dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                            <i className="fa fa-angle-up"></i>
                        </button>
                        <ul className=" dropdown-menu menu-rounded px-1 py-1 fs-2" role="menu">
                            <div className='menu-hover-bg-sec'>
                                <Dropdown.Item
                                    className="menu-item me-lg-0"
                                    onClick={() => submitFilters("Timesheet")}
                                >
                                    <span className="menu-icon custom-menu mb-2">
                                        <i className="bi bi-file-earmark-text fs-6 iconColor">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                    <span className="menu-title custom-menu-fontsize" style={{ paddingRight: 6 }}>
                                        {/* {`${t('Populate Timesheet Records Only')}`} */}
                                        {getValueFromResource('Populate Timesheet Records Only',dispatch, t)}
                                        </span>
                                </Dropdown.Item>
                                <Dropdown.Item
                                    className="menu-item me-lg-0"
                                    onClick={() => submitFilters("Expense")}
                                >
                                    <span className="menu-icon custom-menu mb-2">
                                        <i className="bi bi-file-earmark-text fs-6 iconColor">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                    <span className="menu-title custom-menu-fontsize" style={{ paddingRight: 6 }}>
                                        {/* {`${t('Populate Expense Records Only')}`} */}
                                        {getValueFromResource('Populate Expense Records Only',dispatch, t)}
                                        </span>
                                </Dropdown.Item>
                            </div>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    )
}
const MultiValue = ({ index, getValue, ...props }: any) => {
    const maxToShow = 0;
    const overflow = getValue()
        .slice(maxToShow)
        .map((x: any) => x.label);
    return index < maxToShow ? (
        <components.MultiValue {...props} />
    ) : index === maxToShow ? (
        <>
            <MoreSelectedBadge items={overflow} totalItemCount={props.options.length} />
        </>
    ) : null;
};
const MoreSelectedBadge = ({ items, totalItemCount }: any) => {
    const style = {
        background: "#d4eefa",
        borderRadius: "4px",
        fontSize: "12px",
        padding: "5px"
    };
    const title = items.join(", ");
    const length = items.length;
    const label = length === totalItemCount ? `All Selected(${length})` : ` ${length} Item${length !== 1 ? "s" : ""} Selected`;
    return (
        <div style={style} title={title}>
            {label}
        </div>
    );
};
export default GenerateInvoiceForm